import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container mb-25" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6" }
const _hoisted_4 = { class: "card card-prelogin border-0 rounded-0 bg-white authentication-card" }
const _hoisted_5 = { class: "card-body letter-spacing" }
const _hoisted_6 = { class: "fw-bold mb-0" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = { class: "row justify-content-center" }
const _hoisted_11 = { class: "col col-sm-10 col-md-8 col-lg-7 col-xl-6 col-xxl-6 col-xxxl-6" }
const _hoisted_12 = {
  class: "alert alert-danger alert-dismissible fade border-0 border-danger-subtle border-top rounded-0 m-0",
  role: "alert",
  id: "errorMessage"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.$t('feature.auth.$login.title')), 1 /* TEXT */),
            _createElementVNode("form", {
              id: "login-form",
              onSubmit: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('form.email.label')), 1 /* TEXT */),
                _withDirectives(_createElementVNode("input", {
                  type: "email",
                  title: "Email",
                  class: _normalizeClass(["form-control shadow-none text-black", [{ 'is-invalid': _ctx.submitted && !_ctx.usernameIsValid }]]),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event)),
                  placeholder: _ctx.$t('form.email.placeholder'),
                  required: "",
                  pattern: "[^@\\s]+@[^@\\s]+\\.[^@\\s]+"
                }, null, 10 /* CLASS, PROPS */, _hoisted_9), [
                  [_vModelText, _ctx.username]
                ])
              ]),
              _createCommentVNode(" <div class=\"d-flex align-items-center justify-content-between mb-15 mb-md-20\">\n                <router-link to=\"/forgot-password\"\n                  class=\"forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative\">\n                  {{ $t('feature.auth.forgot_password') }}?\n                </router-link>\n                <router-link to=\"/request-support\"\n                  class=\"forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative\">\n                  {{ $t('feature.auth.request_support') }}\n                </router-link>\n              </div> "),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn transition fw-medium fs-md-15 fs-lg-16 d-block w-100",
                    type: "submit",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setPristine && _ctx.setPristine(...args)))
                  }, _toDisplayString(_ctx.$t('cta.login')), 1 /* TEXT */))
                : (_openBlock(), _createBlock(_component_SpinnerLoading, { key: 1 }))
            ], 32 /* NEED_HYDRATION */)
          ])
        ])
      ])
    ]),
    _createCommentVNode(" ERROR MESSAGE "),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.errorMessage), 1 /* TEXT */),
          _createElementVNode("button", {
            type: "button",
            class: "btn-close",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.hideError && _ctx.hideError(...args))),
            "aria-label": "Close"
          })
        ])
      ])
    ])
  ]))
}